export default __webpack_public_path__ + "static/media/open_in_new-white.0d50f0e0.svg";